import type { FC } from 'react';
import type { ActionConditionVariantProps } from '../../types';
import { observer } from 'mobx-react-lite';
import { useCurrentNetwork } from '../../../../hooks';
import useRulePageMode from '../../hooks/useRulePageMode';
import { Box, Typography } from '@mui/material';
import { AddActionsButton, VerticalDivider } from '../RuleEditComponents';
import AddGoogleActionButton from '../../google/components/AddGoogleActionButton';
import ActionEntry from '../../facebook/components/ActionEntry';

export const ActionsGroup: FC<ActionConditionVariantProps> = observer(({ actions, indexTask, indexVariant }) => {
  const network = useCurrentNetwork();
  const isVariant = typeof indexVariant === 'number';

  const { isRead } = useRulePageMode();
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        maxWidth: '40%',
        gap: 3,
        flexDirection: 'column',
        position: 'relative',
        pl: 4,
        pt: 1,
      }}
    >
      <VerticalDivider />
      <Box sx={{ display: 'flex', justifyContent: 'start', flexDirection: 'column', gap: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 500, mb: 0.75 }}>
          Actions
        </Typography>
        {actions.map((_, indexAction) => (
          <ActionEntry
            key={`ActionGroupEntry.task:${indexTask}.action:${indexAction}.variant:${indexVariant}`}
            indexTask={indexTask}
            indexAction={indexAction}
            indexVariant={indexVariant}
          />
        ))}
      </Box>
      {!isRead && !isVariant && (
        <Box>
          {network === 'facebook' && (
            <AddActionsButton actions={actions} indexTask={indexTask} indexVariant={indexVariant} />
          )}
          {network === 'google' && (
            <AddGoogleActionButton indexTask={indexTask} indexVariant={indexVariant}></AddGoogleActionButton>
          )}
        </Box>
      )}
    </Box>
  );
});

export default ActionsGroup;
